module.exports = __webpack_public_path__ + "img/pdf-2.fc06a01e.jpg";